class State {
  fileName = null;
  filetype = null;
  fileBlob = null;
}

export const getInitState = () => {
  return new State();
};
